import { render, staticRenderFns } from "./TacticPage.vue?vue&type=template&id=cc3db56e&"
import script from "./TacticPage.vue?vue&type=script&lang=js&"
export * from "./TacticPage.vue?vue&type=script&lang=js&"
import style0 from "./TacticPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports